/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CustomerReportsPage } from '@/features/customer/pages/reports'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customer/reports')({
  validateSearch: z.object({
    campaign_id: z.string().optional(),
  }),
  beforeLoad: requireRole(['customer']),
  component: CustomerReportsRoute,
})

function CustomerReportsRoute() {
  const { campaign_id } = Route.useSearch()
  return <CustomerReportsPage campaignId={campaign_id} />
}
